import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.admin.issues.detail');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';
import showdown from 'showdown';
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import { ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-admin-issues-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.admin.issues.detail/view.scss */
/* src/app/portal.admin.issues.detail/view.scss: no such file or directory */`],
})
export class PortalAdminIssuesDetailComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title,@Inject( Router)  private router: Router) { }

    @Input() item: any;

    public info: any = {};
    public comments: any = [];
    public user: any = {};

    public statusList = [
        { label: '접수완료', value: 'submit' },
        { label: '처리중', value: 'process' },
        { label: '처리완료', value: 'finish' },
        // {label:'취소', value:'cancel'}, 
        // {label:'공지', value:'notice'}
    ];

    @ViewChild('editor')
    public editorElement: ElementRef;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("기관 이슈 상세 - MY KREONET");
        await this.load();
        if (this.info.status != 'notice') await this.buildEditor();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { issueID: this.item });
        if (code != 200) return await this.service.alert.error("Error!");
        this.info = data.info;
        this.comments = data.comments;
        this.user = data.user;
        this.info.attachments = JSON.parse(this.info.attachments);
        await this.service.render();
    }

    public async save() {
        this.info.reason = this.editor.data.get();
        const { code, data } = await wiz.call("save", { issueID: this.item, status: this.info.status, reason: this.info.reason });
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success("처리되었습니다.");
    }

    public async remove() {
        let res = await this.service.alert.warning("정말 삭제하시겠습니까?")
        if (res) {
            const { code, data } = await wiz.call("remove", { issueID: this.item });
            if (code != 200) return await this.service.alert.error("Error!");
            await this.service.alert.error("삭제되었습니다.");
            await this.router.navigate([`/admin/issues`]);
        }
    }

    public async download(file: any) {
        let download = wiz.url('download?id=' + this.item + "&name=" + file.name)
        window.open(download, '_blank');
    }

    public async commentWrite(comment: any) {
        if (!comment) return await this.service.alert.warning("댓글을 작성해주세요.");
        this.newComment = comment;
        const { code, data } = await wiz.call("commentWrite", { issueID: this.item, comment: this.newComment });
        if (code != 200) return await this.service.alert.error("Error!");
        this.newComment = "";
        await this.load();
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }

    public async buildEditor() {
        // let editor = this.editor = await ClassicEditor.create(this.editorElement.nativeElement, {
        let editor = this.editor = await ClassicEditor.create(document.querySelector("textarea#editor"), {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    // '|', 'alignment',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    // '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                // items: 'heading | bold italic strikethrough underline | fontColor highlight fontBackgroundColor | bulletedList numberedList todoList | outdent indent | insertTable | link blockQuote code codeBlock'.split(' '),
                shouldNotGroupWhenFull: true
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar", "Markdown"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });

        this.editor.editing.view.change(writer => {
            writer.setStyle('min-height', '300px', editor.editing.view.document.getRoot());
        });

        editor.data.set(this.info?.reason ?? '');
    }

    public async statusChange(v: string) {
        this.info.status = v;
        await this.service.render();
    }

    public formatFileSize(bytes: number) {
        if (!Number.isFinite(bytes)) return '-';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0, size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return `${Math.round(size * 100) / 100} ${units[i]}`;
    }

    public getFileIcon(filename: string) {
        const ext = this.getExt(filename);
        switch (ext) {
            case 'pdf': return '📕';
            case 'doc':
            case 'docx': return '📝';
            case 'xls':
            case 'xlsx': return '📊';
            case 'ppt':
            case 'pptx': return '📈';
            case 'txt': return '📄';
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'webp': return '🖼️';
            default: return '📦';
        }
    }

    private getExt(name: string): string | null {
        const i = name.lastIndexOf('.');
        return i >= 0 ? name.slice(i + 1).toLowerCase() : null;
    }

    public getStatus(status: string) {
        switch (status) {
            case 'notice': return '공지';
            case 'submit': return '접수완료';
            case 'process': return '처리중';
            case 'finish': return '처리완료';
            case 'cancel': return '취소';
            default: return '-';
        }
    }

    public getStatusColor(status: string) {
        switch (status) {
            case 'notice': return 'bg-blue-100 text-blue-800';
            case 'submit': return 'bg-green-100 text-green-800';
            case 'process': return 'bg-yellow-100 text-yellow-800';
            case 'finish': return 'bg-gray-100 text-gray-800';
            case 'cancel': return 'bg-red-100 text-red-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    }

    public getPriorityColor(priority: string) {
        switch (priority) {
            case 'high': return 'bg-red-100 text-red-800';
            case 'middle': return 'bg-yellow-100 text-yellow-800';
            case 'low': return 'bg-green-100 text-green-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    }
}

export default PortalAdminIssuesDetailComponent;